import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Route } from "@angular/router";
import { PageService } from "app/services/page-service";
import { environment } from "environments/environment";

@Component({
  selector: "app-privacy-policy",
  templateUrl: "./privacy-policy.component.html",
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  privacyConfig = environment.privacyConfig;
  data:any;
  appName="ecommercetest";
  date = new Date();
  constructor(public service : PageService,public route : ActivatedRoute) {}

  ngOnInit(): void {
    this.route.params.subscribe((param:any)  => {
      this.appName = param['appName'];
      this.getClientInfo();
    })
  }
  getClientInfo() {
      this.service
        .getClientDetails({
          name : this.appName 
        })
        .then((data) => {
          const clientInfo = data['data'];
          this.privacyConfig = {
            appName: clientInfo['displayName'],
            name: clientInfo['displayName'],
            phone: clientInfo['adminDetails'] && clientInfo['adminDetails']['phoneNo'] ?  clientInfo['adminDetails']['phoneNo'] : "",
            address: "",
            logo : clientInfo['logo'],
            website: "https://"+this.appName+".sass.cruzotec.com/",
            email: clientInfo['adminDetails'] && clientInfo['adminDetails']['email'] ?  clientInfo['adminDetails']['email'] : "",
            state: "",
          }
        })
        .catch((err) => {
          console.log(err);
        });
  }
}
